import api from 'api';
import { actions } from 'store';
import { useDispatch, useReduxState } from 'hooks';
import { ModalButtonWithForm } from 'components/common';
import { Checkbox, FormGroup } from 'components/common/form';

const CompetenciesSettingsButton = () => {
  const { dispatch } = useDispatch();

  const {
    messages,
    serverConfig: { competenciesAllowAdmins }
  } = useReduxState();

  const handleSubmit = async (values) => {
    await api.put(`/admin/server-config`, { data: values });
    const response = await api.get('/admin/server-config');
    dispatch(actions.setServerConfig(response.data.data));
    dispatch(
      actions.addNotice({
        text: messages.settingsSavedSuccessfully,
        type: 'success'
      })
    );
  };

  return (
    <ModalButtonWithForm
      buttonCategory="lighter"
      buttonIcon="cog"
      buttonProps={{
        iconStyle: {
          fontSize: '1rem',
          marginRight: 3
        }
      }}
      buttonSize="small"
      buttonStyle={{
        borderRadius: 30,
        padding: '3px 10px 4px 8px',
        margin: '-2px 0',
        position: 'relative',
        top: -1
      }}
      buttonText={messages.commonSettings}
      formAllowEmptyStrings={true}
      initialValues={{ competenciesAllowAdmins }}
      modalActionCategory="success"
      modalActionText={messages.commonSaveChanges}
      modalTitle={messages.commonSettings}
      modalWidth="medium"
      onSubmit={handleSubmit}
    >
      {(formState) => (
        <FormGroup label={messages.competenciesAllowAdmins}>
          <Checkbox
            field="competenciesAllowAdmins"
            id="competencies-allow-admins"
            label={messages.competenciesAllowAdminsText}
          />
        </FormGroup>
      )}
    </ModalButtonWithForm>
  );
};

export default CompetenciesSettingsButton;
